import { Controller, useFormContext } from 'react-hook-form';

import CustomInput from './CustomInput';
import { MenuItem } from '@mui/material';
import React from 'react';

const ControlledSelectBox = ({ name, options, isRequired = false }) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: isRequired ? '필수 선택 항목입니다.' : undefined,
      }}
      render={({ field, fieldState }) => (
        <CustomInput
          {...field}
          inputRef={field.ref}
          select
          error={fieldState.error !== undefined}
          required={isRequired}
          helperText={fieldState.error ? fieldState.error.message : ''}
        >
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </CustomInput>
      )}
    />
  );
};

export default ControlledSelectBox;
